// Constants
export const ultima_conexion = () => {
  return {
    ultima_conexion: {
      id: {
        namepath: [],
        description: 'type del archivo',
        readonly: true,
        type: 'text',
        datatype: 
        {
          predeterminate: ''
        }
      },
      inicial: {
        namepath: [],
        description: 'name del archivo',
        readonly: true,
        type: 'text',
        datatype: 
        {
          predeterminate: ''
        }
      }, 
      final: {
        namepath: [],
        description: 'name del archivo',
        readonly: true,
        type: 'text',
        datatype: 
        {
          predeterminate: ''
        }
      }, 
    }
  }
}
